export default __webpack_public_path__ + "static/media/mag10.d77e44d8.png";